/** Compatibility shim — AdminView still imports from here */
export const theme = {
  brand: "#0000FF",
  brandMuted: "rgba(0, 0, 255, 0.12)",
  brandDark: "#0000CC",
  metal: "#9aa3b2",
  metalLight: "#c5ccd6",
  metalDark: "#6b7280",
  bg: "#f5f5f5",
  bgDeep: "#ebebeb",
  surface: "#ffffff",
  surfaceMuted: "#f3f3f3",
  surfaceCool: "#f8f9ff",
  border: "#E5E5E5",
  borderStrong: "#0A0A0A",
  text: "#0A0A0A",
  textMuted: "#6B6B6B",
  danger: "#b83030",
  dangerBorder: "#e8d0d0",
  shadowSm: "0 2px 8px rgba(10,10,10,0.06)",
  shadowMd: "0 8px 24px rgba(10,10,10,0.08)",
  shadowInset: "inset 0 1px 0 rgba(255,255,255,0.8)",
  logoShadow: "2px 2px 4px rgba(0,0,0,0.1)",
  fontSans: "'Geist', -apple-system, sans-serif",
  fontSansNarrow: "'JetBrains Mono', ui-monospace, monospace",
  fontSerif: "'Geist', sans-serif",
  logoSizeNav: "40px",
  logoSizeLoading: "64px",
  radius: "0px",
  radiusTight: "0px",
  maxContent: "1440px",
};

export const bodyBackgroundStyle = {
  backgroundColor: "#ffffff",
};

export function metalPanelStyle(extra = {}) {
  return {
    background: "#ffffff",
    border: `1px solid ${theme.border}`,
    borderRadius: "0px",
    boxShadow: theme.shadowSm,
    ...extra,
  };
}

export const accentBar = {
  width: "4px",
  background: theme.brand,
  borderRadius: "0px",
  flexShrink: 0,
};

export function logoImageStyle(sizeKey) {
  const height = sizeKey === "loading" ? theme.logoSizeLoading : theme.logoSizeNav;
  return {
    height,
    width: "auto",
    display: "block",
    mixBlendMode: "multiply",
  };
}
